export const validateVitalsPracticeBaseUrl = raw => {
  if (!raw || !raw.trim()) {
    return { ok: false, error: "URL is required." }
  }

  let u
  try {
    u = new URL(raw)
  } catch {
    return { ok: false, error: "Invalid URL format (include https://)." }
  }

  // 1) Protocol
  if (u.protocol !== "https:") {
    return { ok: false, error: "URL must use HTTPS (https://)." }
  }

  // 2) Host
  const host = u.hostname.toLowerCase()
  if (host !== "www.vitals.com" && host !== "vitals.com") {
    return { ok: false, error: "URL must be on vitals.com." }
  }

  // 3) No query or fragment
  if (u.search) return { ok: false, error: "Query parameters are not allowed." }
  if (u.hash) return { ok: false, error: "Fragments (#...) are not allowed." }

  // 4) Path must be exactly /practice/{slug}-{GUID} (optionally trailing slash)
  const path = u.pathname.replace(/\/+$/, "") // strip trailing slash
  const parts = path.split("/").filter(Boolean)

  if (parts[0] !== "practice") {
    return { ok: false, error: "URL must start with /practice/." }
  }
  if (parts.length !== 2) {
    return {
      ok: false,
      error: "Only the base practice page is allowed (no subpages).",
    }
  }

  const main = parts[1]
  // slug: letters/numbers/hyphens; GUID: canonical UUID v4 style (hex + hyphens)
  const m = main.match(
    /^([a-z0-9]+(?:-[a-z0-9]+)*)-([0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12})$/i,
  )
  if (!m) {
    // Try to give a targeted hint
    const maybeGuid = main.split("-").slice(-5).join("-")
    const guidOk = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(
      maybeGuid,
    )
    return {
      ok: false,
      error: guidOk
        ? "Practice slug looks invalid. Use letters, numbers, and hyphens (e.g., indus-medical-associates)."
        : "Practice GUID looks invalid (expected a UUID like 41bf7bc8-4703-e211-a42b-001f29e3eb44).",
    }
  }

  const [, slug, guid] = m
  return {
    ok: true,
    error: "",
    data: {
      slug,
      guid,
      // normalized to canonical form with www and no trailing slash
      normalizedUrl: `https://www.vitals.com/practice/${slug}-${guid}`,
    },
  }
}
